export const InvoiceItemTypeData = {
  processing_fee_oop: {
    value: 1,
    label: 'Processing Fee (Out of Platform)',
    key: 'processing_fee_oop'
  },
  public_notice_refund: {
    value: 2,
    label: 'Public Notice Refund',
    key: 'public_notice_refund'
  },
  processing_fee_reversal: {
    value: 3,
    label: 'Processing Fee Reversal',
    key: 'processing_fee_reversal'
  },
  individual_invoice: {
    value: 4,
    label: 'Individual Invoice',
    key: 'individual_invoice'
  },
  individual_invoice_voided: {
    value: 5,
    label: 'Individual Invoice Voided',
    key: 'individual_invoice_voided'
  },
  individual_invoice_paid: {
    value: 6,
    label: 'Individual Invoice Paid',
    key: 'individual_invoice_paid'
  },
  individual_invoice_refunded: {
    value: 7,
    label: 'Individual Invoice Refunded',
    key: 'individual_invoice_refunded'
  },
  column_reps_fee: {
    value: 8,
    label: 'Column Reps Fee',
    key: 'column_reps_fee'
  },
  convenience_fee_split: {
    value: 9,
    label: 'Convenience Fee Split',
    key: 'convenience_fee_split'
  },
  auto_affidavit_fee_split: {
    value: 10,
    label: 'Auto Affidavit Fee Split',
    key: 'auto_affidavit_fee_split'
  },
  additional_fee_split: {
    value: 11,
    label: 'Additional Fee Split',
    key: 'additional_fee_split'
  },
  design_fee: {
    value: 12,
    label: 'Design Fee',
    key: 'design_fee'
  },
  // Internally using 'express' terminology, externally labeled as 'placement' for customers
  placement_fee: {
    value: 13,
    label: 'Placement Fee',
    key: 'express_fee'
  },
  placement_fee_refund: {
    value: 14,
    label: 'Placement Fee Refund',
    key: 'express_fee_refund'
  },
  orders_convenience_fee_split: {
    value: 15,
    label: 'Orders Convenience Fee Split',
    key: 'orders_convenience_fee_split'
  },
  publication_cost: {
    value: 16,
    label: 'Publication Cost',
    key: 'publication_cost'
  },
  publication_cost_refund: {
    value: 17,
    label: 'Publication Cost Refund',
    key: 'publication_cost_refund'
  },
  application_fee_oop: {
    value: 18,
    label: 'Application Fee (Out of Platform)',
    key: 'application_fee_oop'
  },
  payment_processing_fee: {
    value: 19,
    label: 'Payment Processing Fee',
    key: 'payment_processing_fee'
  },
  affidavit_fee_oop: {
    value: 20,
    label: 'Affidavit Fee (Out of Platform)',
    key: 'affidavit_fee_oop'
  },

  // Product-specific subscription pricing types
  processing_fee_oop_notice: {
    value: 21,
    label: 'Processing Fee (Out of Platform) - Notice',
    key: 'processing_fee_oop_notice'
  },
  processing_fee_oop_classified: {
    value: 22,
    label: 'Processing Fee (Out of Platform) - Classified',
    key: 'processing_fee_oop_classified'
  },
  processing_fee_oop_obituary: {
    value: 23,
    label: 'Processing Fee (Out of Platform) - Obituary',
    key: 'processing_fee_oop_obituary'
  },
  application_fee_oop_notice: {
    value: 24,
    label: 'Application Fee (Out of Platform) - Notice',
    key: 'application_fee_oop_notice'
  },
  application_fee_oop_classified: {
    value: 25,
    label: 'Application Fee (Out of Platform) - Classified',
    key: 'application_fee_oop_classified'
  },
  application_fee_oop_obituary: {
    value: 26,
    label: 'Application Fee (Out of Platform) - Obituary',
    key: 'application_fee_oop_obituary'
  },
  payment_processing_fee_notice: {
    value: 27,
    label: 'Payment Processing Fee - Notice',
    key: 'payment_processing_fee_notice'
  },
  payment_processing_fee_classified: {
    value: 28,
    label: 'Payment Processing Fee - Classified',
    key: 'payment_processing_fee_classified'
  },
  payment_processing_fee_obituary: {
    value: 29,
    label: 'Payment Processing Fee - Obituary',
    key: 'payment_processing_fee_obituary'
  },
  convenience_fee_split_notice: {
    value: 30,
    label: 'Convenience Fee Split - Notice',
    key: 'convenience_fee_split_notice'
  },
  convenience_fee_split_classified: {
    value: 31,
    label: 'Convenience Fee Split - Classified',
    key: 'convenience_fee_split_classified'
  },
  convenience_fee_split_obituary: {
    value: 32,
    label: 'Convenience Fee Split - Obituary',
    key: 'convenience_fee_split_obituary'
  },
  shipping_fee_oop: {
    value: 33,
    label: 'Shipping Fee (Out of Platform)',
    key: 'shipping_fee_oop'
  }
} as const;

export type InvoiceItemType = typeof InvoiceItemTypeData;

export type InvoiceItemValue = InvoiceItemType[keyof InvoiceItemType]['value'];
export type InvoiceItemKey = InvoiceItemType[keyof InvoiceItemType]['key'];
